import React, { memo, useEffect, useState } from 'react'
import nodataimg from '../../assets/images/searchrates/no-flights.gif'
import { NavLink } from 'react-router-dom';
import Newratelisting from './Newrateslist/Newratelisting';


const NewFlightRatesResult = ({ nodeData }) => {
    return (
        <>
            {
                nodeData && Object.keys(nodeData)?.length > 0 ?
                    <Newratelisting nodeData={nodeData} />:<NoDataPage />
            }
        </>

    )
}

const NoDataPage = memo(() => {
    return (
        <div className="sm:col-span-12 md:col-span-12 lg:col-span-12 col-span-8">
            <div className="w-full rounded-2xl shadow-cardsection bg-white">
                <div className='flex p-5 justify-between items-center flex-wrap gap-5'>
                    <p className="flex font-bold text-lg leading-5">Book Your Cargo</p>
                </div>
                <hr className='border-[#F5F5F5]' />
                <div className='flex p-5 justify-center items-center flex-wrap gap-5 flex-col'>
                    <p className="font-bold text-2xl leading-5 text-[#CCD8E2] mt-5">Sorry, No flights found!</p>
                    <img src={nodataimg} alt="No Search Data" />
                </div>
                <div className='flex p-5 justify-center items-center flex-wrap gap-5'>
                    <p className="font-nomal text-base leading-5 text-center">Worry not! Your Key Account Manager (KAM) will send you the quotes in <NavLink to='/queries' className='font-bold mx-2 text-primary hover:text-secondary'> Queries </NavLink> section!</p>
                </div>
            </div>
        </div>
    )
})
export default React.memo(NewFlightRatesResult)